const ExpressionColors = [
  'var(--color-info-v2)',
  'var(--color-success-v2)',
  'var(--color-status-error)',
  'var(--color-status-warning)',
];

const getTermColor = (colorIndex: number): string => {
  const safeIndex = colorIndex % (ExpressionColors.length - 1);

  try {
    return ExpressionColors[safeIndex];
  } catch (ex) {
    return ExpressionColors[0];
  }
};

export default getTermColor;
